var h = Object.defineProperty;
var p = (n, e, t) =>
  e in n
    ? h(n, e, { enumerable: !0, configurable: !0, writable: !0, value: t })
    : (n[e] = t);
var a = (n, e, t) => p(n, typeof e != "symbol" ? e + "" : e, t);
import { E as u } from "./events.Dnaewmpi.min.js";
class E extends HTMLElement {
  constructor() {
    var t;
    super();
    a(this, "PRODUCT_DATA_SELECTOR", "script[data-product]");
    this.productJSON = JSON.parse(
      ((t = this.querySelector(this.PRODUCT_DATA_SELECTOR)) == null
        ? void 0
        : t.textContent) || "{}",
    );
  }
  connectedCallback() {
    (this.setProperties(), this.setEventListeners());
    this.setupSizeOptionToggles();
    this.updateSizeOptionsOverflow();
    requestAnimationFrame(() => this.updateSizeOptionsOverflow());
  }
  disconnectedCallback() {
    this.removeEventListeners();
  }
  setProperties() {
    this.handleChange = this.onChange.bind(this);
    this.handleResize = this.updateSizeOptionsOverflow.bind(this);
  }
  setEventListeners() {
    this.addEventListener("change", this.handleChange);
    window.addEventListener("resize", this.handleResize);
  }
  removeEventListeners() {
    this.removeEventListener("change", this.handleChange);
    window.removeEventListener("resize", this.handleResize);
  }
  setupSizeOptionToggles() {
    this.querySelectorAll("[data-more-sizes-toggle]").forEach((toggle) => {
      toggle.addEventListener("click", () => {
        const list = toggle.previousElementSibling;
        const isExpanded = list.dataset.expanded === "true";
        list.dataset.expanded = isExpanded ? "false" : "true";
        toggle.textContent = isExpanded
          ? toggle.dataset.moreLabel
          : toggle.dataset.lessLabel;
      });
    });
  }
  updateSizeOptionsOverflow() {
    this.querySelectorAll("[data-size-swatch-list]").forEach((list) => {
      const toggle = list.nextElementSibling;
      if (!toggle?.hasAttribute("data-more-sizes-toggle")) return;

      const rowCount = new Set(
        Array.from(list.children, (item) => item.offsetTop),
      ).size;
      toggle.classList.toggle("hidden", rowCount <= 1);
    });
  }
  onChange(t) {
    const s = t.target;
    let i = JSON.parse(s.getAttribute("data-product"));
    if (!i) throw new Error("No product JSON found, exiting flow...");
    const r = s.getAttribute("data-variant-id"),
      o = i.variants.find((c) => c.id == r),
      d = new CustomEvent(u.PRODUCT_VARIANT_UPDATE, {
        detail: {
          product: i,
          variant: o,
          target: s,
          selectedOptionType: s.getAttribute("data-option-type"),
        },
        bubbles: !0,
      });
    this.dispatchEvent(d);
  }
}
customElements.get("dickies-main-product-standard-options") ||
  customElements.define("dickies-main-product-standard-options", E);
